import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  registerForm: FormGroup;
  submitted = false;

    // <!-- Property declaration -->
fieldTextType1: boolean;
fieldTextType2: boolean;


// <!-- Switching method -->
toggleFieldTextType(num) {
  if(num===1){
    this.fieldTextType1 = !this.fieldTextType1;
  } else if(num===2){
    this.fieldTextType2 = !this.fieldTextType2;
  }
}

  constructor(private formBuilder: FormBuilder,
    ) { }

  ngOnInit() {
    this.createForm();
    // this.fieldTextType1 = false;
    // this.fieldTextType2 = false;
  }

  createForm() {
    this.registerForm = this.formBuilder.group({
      firstName: ["", Validators.required],
      lastName: ["", Validators.nullValidator],     
      ssn: ["", Validators.required],
      phoneNumber: ["",[Validators.required,Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      email: ["", [Validators.required, Validators.email]],
      password: ["",[ Validators.required, Validators.minLength(6)]],
      confirmPassword: ["",[ Validators.required, Validators.minLength(6)]]      
    },
    // { 
    //   validators: this.password.bind(this)
    // }
    );
  }

  password(formGroup: FormGroup) {
    const { value: password } = formGroup.get('password');
    const { value: confirmPassword } = formGroup.get('confirmpassword');
    return password === confirmPassword ? { passwordNotMatch: false } : { passwordNotMatch: true };
  }

    // convenience getter for easy access to form fields
    get f() {
      return this.registerForm.controls;
    }

    onSubmit() {
      this.submitted = true;
  
      // reset alerts on submit
      // this.alertService.clear();
  
      // stop here if form is invalid
      // if (this.registerForm.invalid) {
      //   return;
      // }
      // if (
      //   this.registerForm.controls.username.value === "admin" &&
      //   this.registerForm.controls.password.value === "admin123"
      // ) {
      //   this.loading = true;
      //   this.toastr.success("Welcome Admin!", "Login Success");
      //   this.router.navigate(["/dashboard"]);
      // } else {
      //   this.toastr.error("User name or Password is not valid!", "Error");
      // }
      // let send ={
      //   "UserName": this.registerForm.controls.username.value,
      //   "Password": this.registerForm.controls.password.value
      // }
      // this.authService.login(this.registerForm.controls.username.value,this.registerForm.controls.password.value)
      //     .pipe(first())
      //     .subscribe(
      //         res => {
      //           console.log('login data',res);
      //           this.toastr.success("Welcome Admin!", "Login Success");
      //             // this.router.navigate([this.returnUrl]);
      //         },
      //         err => {
      //           console.log('login err',err);
      //           if(err.status===401){
      //             this.toastr.error("User name or Password is not valid!", "Error");
      //           }
      //         });
    }

}
